module.exports = __webpack_public_path__ + "img/2w.c0ea2696.svg";